import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import { Id } from "@/convex/_generated/dataModel";
import SalePublicView from "@/components/sales/sale-public-view";
import { Spinner } from "@/components/ui/spinner";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

export const Route = createFileRoute("/_public/shared/sales/$id")({
  component: PublicSalePage,
});

function PublicSalePage() {
  const { id } = Route.useParams();

  const sale = useQuery(api.companies.sales.queries.getPublicSale, {
    id: id as Id<"sales">,
  });

  const saleItems = useQuery(
    api.companies.sales.items.queries.getPublicSaleItemsSorted,
    { saleId: id as Id<"sales"> },
  );

  const company = useQuery(
    api.companies.queries.getPublicCompanyWithLogo,
    sale ? { companyId: sale.internalControl.companyId } : "skip",
  );

  if (sale === undefined || saleItems === undefined || company === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <Spinner className="h-8 w-8 mx-auto mb-4" />
          <p className="text-muted-foreground">Cargando venta...</p>
        </div>
      </div>
    );
  }

  if (sale === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <Card className="w-full max-w-md">
          <CardHeader>
            <CardTitle className="text-center text-destructive">
              Venta no disponible
            </CardTitle>
          </CardHeader>
          <CardContent>
            <Alert variant="destructive">
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>
                La venta que buscas no existe o no esta disponible para
                visualizacion publica.
              </AlertDescription>
            </Alert>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <SalePublicView
        sale={sale}
        saleItems={saleItems || []}
        company={company}
      />
    </div>
  );
}
